<div class="speaker-container" [id]="'speaker-x-ray-' + speakerSlot.speaker.speakerTag">
  <div class="speaker">
    @if (isEditing) {
      <div class="update-container">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'CALLS.SPEAKERS.SPEAKER_NAME' | translate }}</mat-label>
          <input matInput autoFocus name="name" [(ngModel)]="name" [matAutocomplete]="auto" #nameInput (input)="filterAttendeeNames()" />
          <mat-autocomplete #auto="matAutocomplete" class="mask-attendee-names" (optionSelected)="save()">
            @for (attendeeName of filteredAttendeeNames; track $index) {
              <mat-option [value]="attendeeName">
                {{ attendeeName }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-icon [class.clickable]="isNameValid" (click)="save()" [class.disabled]="!isNameValid">check</mat-icon>
        @if (isLabelingModeFocusedOnSpeaker) {
          <mat-icon class="clickable" (click)="skipLabeling()" [matTooltip]="'CALLS.SPEAKERS.SKIP_LABELING_SPEAKER' | translate">double_arrow</mat-icon>
        } @else {
          <mat-icon class="clickable" (click)="isEditing = false">close</mat-icon>
        }
      </div>
    } @else {
      <div class="name">
        <div class="label clickable" [class.disabled]="!canEdit" [class.active]="isActive" (click)="enableEditing()">
          {{ speakerSlot.speaker | speaker: call.userSpeakerMapping! }}
          @if (isAutolabelled(speakerSlot.speaker)) {
            <span class="auto-label-chip">{{ 'CALLS.SPEAKERS.AUTOLABELLED' | translate }}</span>
          }
        </div>
        @if (canEdit) {
          <span class="edit clickable" (click)="enableEditing()" [matTooltip]="'CALLS.SPEAKERS.EDIT_SPEAKER_NAME' | translate">
            <mat-icon>edit</mat-icon>
          </span>
          @if (hasMultipleSpeakers(speakerSlot)) {
            <span class="clickable edit" [matTooltip]="'CALLS.SPEAKERS.SPLIT_SPEAKERS' | translate" (click)="handleSplitSpeakers()">
              <mat-icon>call_split</mat-icon>
            </span>
          }
        }
      </div>
    }
  </div>
  <div class="x-ray-container clickable" (click)="chooseTimeBasedOnClickCoordinates($event)">
    @for (speakerSegment of speakerSlot.segments; track $index) {
      <div
        class="item"
        [style.background-color]="speakerNameToColor(speakerSegment.originalTag)"
        [style.left]="speakerSegment.left + '%'"
        [style.width]="speakerSegment.width + '%'"
      ></div>
    }
  </div>
</div>
